<template>
  <modal class="alertModal" :show="isAlertOpen" :closeModal="closeModal" :class="{ none_message: !message }">
    <h1 slot="header" v-html="header"></h1>
    <div slot="body" v-html="message"></div>
    <div slot="footer">
      <button class="btn btn01" @click="handleClick(true)" ref="btn">
        {{ $t('common.confirm') }}
      </button>
    </div>
  </modal>
</template>

<script>
import Modal from '@/components/modules/common/Modal';
import { mapActions, mapGetters } from 'vuex';

export default {
  props: {},
  watch: {
    isAlertOpen: function (val) {
      if (val) {
        this.buttonFocus();
      }
    },
  },
  components: {
    Modal,
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters('modal', ['isAlertOpen', 'header', 'message', 'callback']),
  },
  methods: {
    ...mapActions('modal', ['closeModal']),
    handleClick(callCallback) {
      if (callCallback && typeof this.callback === 'function') {
        this.callback();
      }
      this.closeModal();
    },
    buttonFocus() {
      setTimeout(() => {
        const btn = this.$refs.btn;
        if (btn) {
          btn.focus();
        }
      }, 100);
    },
  },
  mounted() {
    this.buttonFocus();
  },
};
</script>
